<template>
  <f7-page name="hydro-spravodajstvo" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Hydrologické spravodajstvo</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-block class="no-margin no-padding">

        <f7-block strong class="mt-0 mb-0 text-align-center padding-half z-index-200 position-sticky top-0">
          <f7-row>
            <f7-col>
              <f7-searchbar
                  search-container=".search-list"
                  search-in=".item-title"
                  placeholder="Hľadať..."
                  disable-button-text="Zrušiť"
                  :remove-diacritics="true"
                  :disable-button="!$theme.aurora"
              ></f7-searchbar>
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col class="padding-top-half">
              {{ situationDt | moment('DD.MM.YYYY HH:mm') }}
            </f7-col>
          </f7-row>

        </f7-block>

        <template v-if="situationData.length > 0">
          <f7-list class="searchbar-not-found no-margin-top">
            <f7-list-item title="Nič nebolo nájdené..." subtitle="Skúste zmeniť parametre vyhľadávania..."></f7-list-item>
          </f7-list>
          <f7-list media-list class="search-list searchbar-found no-margin-top vodnestavy">
            <f7-list-item v-for="(item, index) in situationData"
                          :key="item.station_id"
                          :title="item.station_name"
                          :link="'/vodne-stavy/'+item.mars_station_id"
            >
              <div class="item-footer-x">
                <table class="hs-table-small data-table">
                  <thead>
                  <tr>
                    <th>H</th>
                    <th>∆H</th>
                    <th>Q</th>
                    <th>T<sub>vo</sub></th>
                    <th>T<sub>vz</sub></th>
                    <th>Z</th>
                    <th>Q<sub>M,N</sub></th>
                    <th>P</th>
                    <th>L</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :class="`hs-spa-`+item.pa">
                    <td>{{ item.h }}</td>
                    <td>{{ item.dh }}</td>
                    <td>{{ item.q }}</td>
                    <td>{{ item.tvod }}</td>
                    <td>{{ item.tvzd }}</td>
                    <td>{{ item.zra }}</td>
                    <td>{{ item.qmn }}</td>
                    <td class="wh-wrap">{{ item.weather_text }}</td>
                    <td>{{ item.ice_index }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </f7-list-item>
          </f7-list>
        </template>

      </f7-block>

    </template>


    <h4 class="text-align-center">Legenda</h4>
    <div class="card z-index-100 data-table">
      <table class="hs-table-legenda">
        <thead>
        <tr>
          <th>Stupne povodňovej aktivity</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="hs-spa-1">1. stupeň</td>
        </tr>
        <tr>
          <td class="hs-spa-2">2. stupeň</td>
        </tr>
        <tr>
          <td class="hs-spa-3">3. stupeň</td>
        </tr>
        </tbody>
      </table>
      <br>

      <table class="hs-table-legenda">
        <thead>
        <tr> <td colspan="2"> Popis hlavičky: </td> </tr>
        </thead>
        <tbody>
        <tr> <td>H </td><td class="text-align-left">Vodný stav [cm]</td> </tr>
        <tr> <td>∆H</td><td class="text-align-left">Rozdiel zo včera [cm]</td> </tr>
        <tr> <td>Q</td><td class="text-align-left">Prietok [m<sup>3</sup>/s]</td> </tr>
        <tr> <td>T<sub>vo</sub></td><td class="text-align-left">Teplota vody [°C]</td> </tr>
        <tr> <td>T<sub>vz</sub></td><td class="text-align-left">Teplota vzduchu [°C]</td> </tr>
        <tr> <td>Z</td><td class="text-align-left">Zrážky (XX – zrazky sa nemerajú, //  - zrážky sa nevyskytli) [mm]</td> </tr>
        <tr> <td>Q<sub>M,N</sub></td><td class="text-align-left">m-dennosť vody (20 = 20 denná voda, 2R = dvojročná voda)</td> </tr>
        <tr> <td>P</td><td class="text-align-left">Počasie</td> </tr>
        <tr> <td>L</td><td class="text-align-left">Ľad</td> </tr>
        <tr> <td>//</td><td class="text-align-left">Zrážky sa nevyskytli</td> </tr>
        <tr> <td>-</td><td class="text-align-left">Údaje nie sú k dispozícii</td> </tr>
        </tbody>
      </table>

      <br>
      <table class="hs-table-legenda">
        <thead>
        <tr>
          <th colspan="2">Index ľadu</th>
        </tr>
        </thead>
        <tbody>
        <tr><td>0</td><td class="text-align-left">Bez ľadu</td></tr>
        <tr><td>1</td><td class="text-align-left">Ľadová triešť</td></tr>
        <tr><td>2</td><td class="text-align-left">Ľadová triešť a ľad pri brehu</td></tr>
        <tr><td>3</td><td class="text-align-left">Ľad pri brehu</td></tr>
        <tr><td>4</td><td class="text-align-left">Zámrz rieky (úplný)</td></tr>
        <tr><td>5</td><td class="text-align-left">Ľadová zápcha (v profile vodočtu)</td></tr>
        <tr><td>6</td><td class="text-align-left">Ľadochod</td></tr>
        <tr><td>7</td><td class="text-align-left">Voda tečúca po ľade</td></tr>
        <tr><td>8</td><td class="text-align-left">Chod ľadu a ľad pri brehu</td></tr>
        </tbody>
      </table>




    </div>


  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";


export default {
  data: function () {
    return {
      situationData: [],
      situationDt: null,
      isDataLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
    };
  },
  computed: {
    situationDtTs() {

    }
  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');

  },
  updated() {


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getcurrentdata', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.situationData = response.data.data;
                self.situationDt = response.data.dt;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne hydrologické spravodajstvo', 'Nastala chyba');
              }

              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    }
  }

};
</script>

<style lang="scss">


.hs-table-small {
  border-collapse: collapse;
  max-width: 400px;

  /*
  tr {
    border: 0px;
  }
   */
  td, th {
    padding: 3px 5px;
    min-width: 20px;
    border: 1px solid var(--f7-table-cell-border-color);
    border-collapse: collapse;
    height: 20px !important;
    font-size: 10px !important;
    /*
    &:first-child {
      border-left: 0;
    }
    */

    /*
    &:last-child {
      border-right: 0;
    }

     */
  }
  th {
    font-weight: bold !important;
    font-size: 10px !important;
    text-align:center;
  }
}

.wh-wrap {
  white-space: pre-wrap;
}

.wh-nowrap {
  white-space: nowrap;
}

.hs-spa-1 {
  background-color: rgb(255, 255, 1);
  color: black;
}

.hs-spa-2 {
  background-color: rgb(243, 138, 57);
  color: white;
}

.hs-spa-3 {
  background-color: rgb(254, 1, 4);
  color: white;
}



.hs-table-legenda {
  border-collapse:collapse;
  td, th {
    padding: 3px 2px;
    border-right: 1px solid var(--f7-table-cell-border-color);
    border-collapse:collapse;
    &:first-child { border-left: 0;}
    &:last-child { border-right: 0;}
    height: 20px !important;
    white-space: nowrap;
    text-align: center;
  }
  th {
    text-align:center;

  }
  td {
    &:first-child { font-weight:bold;}
    font-size:10px;
  }

}
</style>
